import React, { Fragment } from "react";
import { dataFormatters } from "../../../../utils/dataFormatters";

const FraCodeTitleFormatter = (title_values) => {
  if (Array.isArray(title_values)) {
    return <div style={{ top: '50%', position: 'absolute', transform: 'translate(-50%, -50%)', left: '50%', width: '200px' }}>
      {title_values.map(val => <div style={{ minWidth: 'max-content' }}>{`${val}`}</div>)}
    </div>
  }

  return title_values;
}

export const SFRTA_LockingTestsAndInspectionsReportSchema = {
  sections: [
    {
      heights: {
        header1: "auto",
        header2: "160px",
      },
      classes: {
        header1: 'fs-24'
      },
      minDataRowsCount: 6,
      columns: [
        {
          title: "Locking Tests",
          colSpan: 22,
          rowSpan: 1,
          className: "tbl-text-normal",
          columns: [
            {
              title: "Route Nomenclature",
              colSpan: 10,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: 'nomen',
              dataClassName: "text-left pd-left-10px d-block",
            },
            {
              title: ["Mechanical", "(FRA 236.376)"],
              titleFormatter: FraCodeTitleFormatter,
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-rotate-multiline",
              accessor: 'mech',
            },
            {
              title: ["Approach", "(FRA 236.377)"],
              titleFormatter: FraCodeTitleFormatter,
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-rotate-multiline",
              accessor: 'app',
            },
            {
              title: ["Time", "(FRA 236.378)"],
              titleFormatter: FraCodeTitleFormatter,
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-rotate-multiline",
              accessor: 'time',
            },
            {
              title: ["Route", "(FRA 236.379)"],
              titleFormatter: FraCodeTitleFormatter,
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-rotate-multiline",
              accessor: 'route',
            },
            {
              title: ["Indication", "(FRA 236.380)"],
              titleFormatter: FraCodeTitleFormatter,
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-rotate-multiline",
              accessor: 'indic',
            },
            {
              title: ["Traffic", "(FRA 236.381)"],
              titleFormatter: FraCodeTitleFormatter,
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-rotate-multiline",
              accessor: 'traf'
            },
          ],
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/SFRTA/LockingTestsAndInspectionsReport/SFRTA_LockingTestsAndInspectionsReportSchema.js